import type { BFFArticleBodyElement } from "@src/app/types/bff";

import ArticleImage from "./ArticleImage";
import ArticleYoutube from "./ArticleYoutube";

export default function ArticleMedia({
  element,
}: {
  element: BFFArticleBodyElement["media"];
}) {
  const { elements = [] } = element;

  return elements.map((item, index) => {
    if (item.type == "image") {
      return <ArticleImage key={index} element={{ ...item }} />;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (item.type == "youtube_video") {
      return <ArticleYoutube key={index} element={{ ...item }} />;
    }
    return null;
  });
}
